module.exports = __webpack_public_path__ + "img/part3.fa700128.png";